import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column, List } from '@pella/sash-framework';
import { CTA, Image } from '../..';

import styles from './index.module.scss';

const CTARibbon = ({ data, split = false, className }) => {
	if (!data || !data.group) return null;

	const setBgColor = (color) => {
		switch (color) {
			case 'light gray':
				return styles.ctaRibbon_lightGray;
			case 'white':
				return styles.ctaRibbon_white;
			case 'dark':
				return styles.ctaRibbon_dark;
			case 'black':
				return styles.ctaRibbon_black;
			default:
				return '';
		}
	};

	const renderHeading = () => (
		<div
			className={styles.ctaRibbon_Heading}
			dangerouslySetInnerHTML={{ __html: data.group.heading }}
		/>
	);

	const renderSubheading = () => (
		<div
			className={styles.ctaRibbon_Subheading}
			dangerouslySetInnerHTML={{ __html: data.group.subheading }}
		/>
	);

	const renderDisclaimer = () => (
		<div
			className={styles.ctaRibbon_Disclaimer}
			dangerouslySetInnerHTML={{ __html: data.group.disclaimer }}
		/>
	);

	const renderImage = () => (
		<Image
			data={{ image: data.group.icon }}
			className={styles.ctaRibbon_Image}
		/>
	);

	const renderBtns = (layout = 'fluid') => (
		<List
			bullets='none'
			layout={layout}
			className={styles.ctaRibbon_BtnList}
		>
			{data.group.ctas.map((link, index) => (
				<li key={index}>
					<CTA
						data={link}
						className={`${styles.ctaRibbon_Btn} ctaRibbon-Btn`}
					/>
				</li>
			))}
		</List>
	);

	return (
		<div className={`${styles.ctaRibbon} ${setBgColor(data.group.background_color)} ${className || ''}`}>
			{data.ribbon_style === 'for pros' && (
				<div className={`${styles.ctaRibbon_ForPros} ${split ? styles.ctaRibbon_ForPros_split : ''}`}>
					{data.group.icon?.gatsbyImageData && renderImage()}
					{data.group.heading && renderHeading()}
					{data.group.subheading && renderSubheading()}
					{data.group.ctas?.[0] && renderBtns()}
				</div>
			)}

			{data.ribbon_style === 'financing' && (
				<div className={styles.ctaRibbon_Financing}>
					{data.group.subheading && renderSubheading()}
					{data.group.heading && renderHeading()}
					{data.group.disclaimer && renderDisclaimer()}
					{data.group.ctas?.[0] && renderBtns()}
				</div>
			)}

			{data.ribbon_style === 'feature' && (
				<div className='flex flex-col p-4 md:flex-row'>
					<span className='mb-4 flex-grow md:mb-0 md:mr-4'>
						{data.group.subheading && <p className='text-overline w-fit bg-primary px-[14px] py-1'>{data.group.subheading}</p>}
						{data.group.heading && (
							<div
								className='text-h3 my-2.5'
								dangerouslySetInnerHTML={{ __html: data.group.heading }}
							/>
						)}
						{data.group.description && <div dangerouslySetInnerHTML={{ __html: data.group.description }} />}
					</span>
					{data.group.ctas?.[0] && (
						<CTA
							className='md:self-center md:[&>span]:w-max'
							data={data.group.ctas[0]}
						/>
					)}
				</div>
			)}

			{(data.ribbon_style === 'learn more' || data.ribbon_style === 'image') && (
				<div className={`${styles.ctaRibbon_LearnMore} ${data.group.icon?.gatsbyImageData ? styles.ctaRibbon_hasImage : ''}`}>
					{data.group.icon?.gatsbyImageData && renderImage()}
					<Row
						align='center'
						className={styles.ctaRibbon_Row}
					>
						<Column
							xs={12}
							md='fluid'
						>
							{data.group.heading && renderHeading()}
							{data.group.subheading && renderSubheading()}
						</Column>

						<Column
							xs={12}
							md='auto'
						>
							{data.group.ctas?.[0] && renderBtns()}
						</Column>
					</Row>
				</div>
			)}

			{data.ribbon_style === 'all cta' && <div className={styles.ctaRibbon_AllCta}>{data.group.ctas?.[0] && renderBtns('inline')}</div>}

			{data.ribbon_style === 'contact us' && (
				<div className={`${styles.ctaRibbon_ContactUs} mx-auto flex max-w-4xl flex-row flex-wrap items-center`}>
					{data.group?.heading && (
						<div className='flex-12/12 lg:max-w-5/12 lg:flex-5/12'>
							<p className='mb-8 text-3xl font-semibold leading-tight md:mb-6 md:text-[2rem] lg:mb-0'>{data.group.heading}</p>
						</div>
					)}

					{data.group.ctas?.[0] && <div className='flex-12/12 lg:flex-1 lg:pl-12'>{renderBtns('block')}</div>}
				</div>
			)}
		</div>
	);
};

CTARibbon.propTypes = {
	data: PropTypes.object,
	split: PropTypes.bool,
	className: PropTypes.string,
};

export default CTARibbon;
